class LoginController {
    /*@ngInject*/
    constructor($log, $rootScope, $http, $compile, $scope, $timeout, HeaderNavigationService, CommonService, FetchForgottenPasswordFormService) {
        $log.debug('LoginController initialized');
        this.headerNavigationService = HeaderNavigationService;
        this.CommonService = CommonService;
        this.FetchForgottenPasswordFormService = FetchForgottenPasswordFormService;
        this.requestPending = false;
        this.loginError = null;
        this.$rootScope = $rootScope;
        this.$http = $http;
        this.$log = $log;
        this.$compile = $compile;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.credentials = {
            name: '',
            password: ''
        };
        $rootScope.$on('personalizeRequestSuccess', () => {
            this.credentials.name = this.CommonService.getPersonalizeRequestResponse().email;
        });

        this.$rootScope.$on('submitLoginFinished', () => {
            this.requestPending = false;
            let loginResponse = this.headerNavigationService.getLoginResponse();
            if (loginResponse.success == true) {
                if (window.location.href.endsWith('login')
                    || window.location.href.endsWith('login/')) {
                    window.location.replace(this.CommonService.getBaseUrl() + '/account');
                } else {
                    window.location.reload(true);
                }
            } else {
                this.loginError = loginResponse.errors[0];
                // this.$scope.loginForm.j_username.$setValidity('email', false);
                this.credentials.password = null;
            }
        });
        // HACK: trigger JavaScript form validation (LSEC-9820)
        if ($('#j_username').length) {
            document.querySelector('#j_username').focus();
            $timeout(function () {
                document.querySelector('#j_username').blur();
            }, 10);
        }
    }

    getLoginError() {
        return this.loginError;
    }

    submit(form) {
        this.requestPending = true;
        form.$$element.submit();
    }

    submitAjaxLogin(url) {
        this.requestPending = true;
        this.loginError = null;
        this.headerNavigationService.submitLogin(url, this.credentials.name, this.credentials.password, false, false);
    }

    passwordForgotten() {
        // try to close the login modal. Only one modal is allowed
        this.$rootScope.$broadcast('hideLoginModal');
        //create and init modal window if it is not already in the DOM
        this.FetchForgottenPasswordFormService.fetchForgottenPasswordForm();
    }

    requestSubmit(event, form) {
        if (event.keyCode === 13 && form.$valid) {
            this.$timeout(() => {
                form.$$element[0].querySelector('.js-submit').click();
            });
        }
    }
}

export default LoginController;
